var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHeart1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.2498 2.5C16.7812 2.5 18.8332 4.58333 18.8332 7.5C18.8332 13.3333 12.5832 16.6667 10.4998 17.9167C8.4165 16.6667 2.1665 13.3333 2.1665 7.5C2.1665 4.58333 4.24984 2.5 6.74984 2.5C8.29981 2.5 9.6665 3.33333 10.4998 4.16667C11.3332 3.33333 12.6998 2.5 14.2498 2.5Z",
    fill: "#FF8CBD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHeart1);
export default __webpack_public_path__ + "static/media/icon-heart1.f49f46bfcf355e3edbbd3a31253705dd.svg";
export { ForwardRef as ReactComponent };